import { render, staticRenderFns } from "./draggable_compat.vue?vue&type=template&id=c1d69464"
import script from "./draggable_compat.vue?vue&type=script&lang=js"
export * from "./draggable_compat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports